export const UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY = [
  "unified-inbox",
  "support",
  "conversations",
] as const;

export const unifiedInboxSupportConversationKey = {
  all: () => UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY,
  detail: (id?: string) =>
    [...UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY, id] as const,
  list: (type: string, status: string) =>
    [
      ...UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY,
      "list",
      type,
      status,
    ] as const,
  listRoot: () =>
    [...UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY, "list"] as const,
  unreadCount: () =>
    [...UNIFIED_INBOX_SUPPORT_CONVERSATIONS_QUERY_KEY, "unread-count"] as const,
};
